/**
 * PromoBanner.tsx — lyseblå promo-stripe (ibm.com): tittel + tekst til venstre,
 * knapp til høyre. Brukes på /webhotell og på forsiden.
 */

import LandingButton from '@/components/landing/LandingButton';
import type { LandingPromo } from '@/types/landing';
import styles from './product.module.css';

export default function PromoBanner({ promo }: { promo: LandingPromo }) {
  return (
    <section className={styles.promoWrap} aria-labelledby="promo-title">
      <div className={styles.container}>
        <div className={styles.promo}>
          <div>
            <h2 id="promo-title" className={styles.promoTitle}>
              {promo.title}
            </h2>
            <p className={styles.promoBody}>{promo.body}</p>
          </div>
          <LandingButton link={promo.cta} kind="primary" />
        </div>
      </div>
    </section>
  );
}
